export const APPLICATION_GRAPH_NODE_RADIUS = 100;
